import axios from 'axios'

const passwordAxios = axios.create({
  baseURL: 'https://api.corporateportal.plick.eu/userservice/apipassword',
  headers: {
    'content-type': 'application/json',
    'Accept': 'application/json'
  }
})

export default passwordAxios
